var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_391_11684)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 8.21V9.978C10.5001 10.1046 10.4521 10.2265 10.3658 10.3191C10.2795 10.4117 10.1613 10.4681 10.035 10.477C9.8165 10.492 9.638 10.5 9.5 10.5C5.0815 10.5 1.5 6.9185 1.5 2.5C1.5 2.362 1.5075 2.1835 1.523 1.965C1.53186 1.83872 1.58829 1.72051 1.6809 1.6342C1.77351 1.5479 1.89541 1.49994 2.022 1.5H3.79C3.85202 1.49994 3.91185 1.52293 3.95786 1.56451C4.00388 1.60609 4.0328 1.66329 4.039 1.725C4.0505 1.84 4.061 1.9315 4.071 2.001C4.17037 2.69446 4.374 3.36892 4.675 4.0015C4.7225 4.1015 4.6915 4.221 4.6015 4.285L3.5225 5.056C4.18223 6.59323 5.40727 7.81827 6.9445 8.478L7.7145 7.401C7.74597 7.357 7.79189 7.32544 7.84425 7.31183C7.8966 7.29821 7.95208 7.3034 8.001 7.3265C8.63351 7.62693 9.30779 7.83006 10.001 7.929C10.0705 7.939 10.162 7.95 10.276 7.961C10.3376 7.96732 10.3947 7.99629 10.4362 8.04229C10.4777 8.08829 10.5006 8.14806 10.5005 8.21H10.5Z",
    fill: "#FFCE00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_391_11684"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhone);
export default __webpack_public_path__ + "static/media/icon_phone.a66760b82fc44a6da3202970f7b5be21.svg";
export { ForwardRef as ReactComponent };